import React from 'react';
import { useRouter } from 'next/router';
import PropTypes, { InferProps } from 'prop-types';
import Company from '.';
import withQuery from '../../lib/withQuery';
import profileBySlugQuery
  from '../../lib/queries/products/profileBySlugQuery.graphql';
import {
  companyProfileCollectionImageConfigurations,
  companyProfileImageConfigurations,
  companyProfileLogoImageConfigurations,
  companyProfileMobileImageConfigurations,
} from '../../lib/imageConfigurations';

const CompanyWithQuery = withQuery(Company);

const companyLayoutPropertyTypes = {
  children: PropTypes.node.isRequired,
  layoutMaxWidth: PropTypes.string,
  layoutMarginBottom: PropTypes.string,
  throwOnCompanyNotFound: PropTypes.bool,
};

type CompanyLayoutProperties = InferProps<typeof companyLayoutPropertyTypes>;

const CompanyLayout = ({
  children,
  layoutMaxWidth,
  layoutMarginBottom,
  throwOnCompanyNotFound,
}: CompanyLayoutProperties) => {
  const { query: { slug } } = useRouter();

  return (
    <CompanyWithQuery
      query={profileBySlugQuery}
      variables={{
        slug,
        imageConfigurations: companyProfileImageConfigurations,
        mobileImageConfigurations: companyProfileMobileImageConfigurations,
        logoConfigurations: companyProfileLogoImageConfigurations,
        collectionImageConfigurations:
        companyProfileCollectionImageConfigurations,
      }}
      errorMessage="Error loading this company profile"
      layoutMaxWidth={layoutMaxWidth ?? '100vw'}
      layoutMarginBottom={layoutMarginBottom ?? null}
      throwOnCompanyNotFound={throwOnCompanyNotFound}
    >
      {children}
    </CompanyWithQuery>
  );
};

CompanyLayout.propTypes = companyLayoutPropertyTypes;

export default CompanyLayout;
